import { createFileRoute } from '@tanstack/react-router'
import ValidateContainer from '@/containers/Validate'

export const Route = createFileRoute('/$locale/validate/$authInfo')({
  component: Validate,
})

function Validate() {
  const { authInfo } = Route.useParams()
  return (
    <ValidateContainer authInfo={authInfo} />
  )
}
